import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { IQuestionEventsService } from 'shared-components';

import { QuestionAnswerFail } from 'app/question/components/question/models/question-answer-fail';
import { IQuestionAnswerSuccess } from 'app/question/components/question/models/question-answer-success';

export type QuestionClosedEvent = {
  byTeacher?: boolean;
};

@Injectable({
  providedIn: 'root'
})
export class QuestionEventsService implements IQuestionEventsService {
  public submitAnswerCompleted = new Subject<IQuestionAnswerSuccess>();
  public submitAnswerFailed = new Subject<QuestionAnswerFail | void>();
  public questionClosed = new Subject<QuestionClosedEvent>();

  public hideInputOnlyForManip = new BehaviorSubject(false);
  public hideAllInputForManip = new BehaviorSubject(false);
  public hideStudentManipControlBar = new BehaviorSubject(false);

  public disableButtonForPuzzle = new BehaviorSubject(false);
  private puzzleSubmitSubject = new Subject<void>();
  public puzzleSubmit$ = this.puzzleSubmitSubject.asObservable();
  public controlClicked = new BehaviorSubject(false);

  public puzzleSubmitButtonClicked(): void {
    this.puzzleSubmitSubject.next();
  }
}
